import React from 'react';
import { ThemeEnum } from '../../../../enum/Theme';

interface Props {
  theme: ThemeEnum;
  onToggle: () => void;
}

const ThemeToggle: React.FC<Props> = ({ theme, onToggle }) => {
  return (
    <div className="wrapper">
      <span className="label">Select theme</span>

      <button className="switch" data-theme={theme} onClick={onToggle}>
        <span className="thumb"></span>
        <span className="text">{theme === ThemeEnum.DARK ? 'DARK' : 'LIGHT'}</span>
      </button>
    </div>
  );
};

export default ThemeToggle;
